<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="card-body">
      <h3 class="mb-4 title">Enter WhatsApp Number</h3>

      <form [formGroup]="whatsappForm" *ngIf="whatsappForm">
        <div class="mb-3">
          <div class="input-container">
            <label for="whatsappNumber" class="label">WhatsApp Number</label>
            <div
                [ngClass]="{ 'invalid-input': whatsappForm.get('whatsappNumber')?.invalid && whatsappForm.get('whatsappNumber')?.touched }">
                <app-phone-country-input formControlName="whatsappNumber"></app-phone-country-input>
              </div>
          </div>
        </div>

        <ion-button type="submit" class="filled-blue-btn" [disabled]="whatsappForm.invalid" (click)="onSubmit()">
          Submit
        </ion-button>
      </form>
    </div>
  </div>
</div>
